import { oneKlicks } from '../SDK/oneclick';

export const getPackagesFromDB = async () => {
  try {
    const tableSchema = "";
    const tableName = "packages";
    const conditions = { 
      status: 'active' 
    };
    const orderBy = "price ASC";
    const search = {};
    const pagination = {};
    const margedata = [];

    const response = await oneKlicks.read(tableSchema, tableName, conditions, orderBy, search, pagination, margedata);

    console.log('Raw response from oneKlicks:', response);
    
    if (response.success && response.data) {
      return response.data.map(pkg => ({
        id: pkg.id,
        name: pkg.name,
        price: parseFloat(pkg.price) || 0,
        originalprice: parseFloat(pkg.originalprice || pkg.orginalprice) || 0,
        period: pkg.period || 'Monthly',
        baseCurrency: pkg.base_currency || 'INR',
        image: pkg.image,
        heading: pkg.heading,
        description: pkg.description,
        sms: pkg.sms || "0",
        whatsup_count: pkg.whatsup_count || "0",
        email: pkg.email || "0",
        patient_count: pkg.patient_count || "0",
        socialposts: pkg.socialposts || "0",
        socialvideos: pkg.socialvideos || "0",
        website_pages: pkg.website_pages || "0",
        autopost: pkg.autopost || "no",
        chatsupport: pkg.chatsupport || "no",
        featureddays: pkg.featureddays || "0",
        hms: pkg.hms || "no",
        featuredprofile: pkg.featuredprofile || "no",
        professionalwebsite: pkg.professionalwebsite || pkg.profesionalwebsite || "no",
        key: pkg.slug || pkg.name?.toLowerCase()
      }));
    }
    
    return [];
  } catch (error) {
    console.error('Error fetching packages:', error);
    return [];
  }
};

export const getServicesFromDB = async () => {
  try {
    const tableSchema = "";
    const tableName = "ourservices";
    const conditions = { status: 'active' };
    const orderBy = "id ASC";
    const search = {};
    const pagination = {};
    const margedata = [];

    console.log('Fetching services from table:', tableName);
    const response = await oneKlicks.read(tableSchema, tableName, conditions, orderBy, search, pagination, margedata);
    
    console.log('Raw response from oneKlicks:', response);
    
    if (response.success && response.data) {
      console.log('Raw data from database:', response.data);
      
      const mappedServices = response.data.map(service => {
        try {
          return {
            id: service.id,
            slug: service.slug,
            title: service.name,
            description: service.description,
            basePrice: parseFloat(service.base_price) || 0,
            baseCurrency: service.base_currency || 'INR',
            icon: service.icon || '🏥',
            category: service.category || 'general',
            features: JSON.parse(service.features || '[]'),
            status: service.status,
            created_at: service.created_at,
            updated_at: service.updated_at
          };
        } catch (parseError) {
          console.error('Error parsing service:', service, parseError);
          return null;
        }
      }).filter(Boolean); // Remove null entries
      
      console.log('Mapped services:', mappedServices);
      return mappedServices;
    }
    
    console.log('No data returned from database');
    return [];
  } catch (error) {
    console.error('Error fetching services:', error);
    return [];
  }
};

export const getPackageById = async (packageId) => {
  try {
    const tableSchema = "";
    const tableName = "packages";
    const conditions = { id: packageId, status: 'active' };
    const orderBy = "id DESC";
    const search = {};
    const pagination = {};
    const margedata = [];

    const response = await oneKlicks.read(tableSchema, tableName, conditions, orderBy, search, pagination, margedata);
    
    if (response.success && response.data && response.data.length > 0) {
      const pkg = response.data[0];
      return {
        id: pkg.id,
        name: pkg.name,
        price: parseFloat(pkg.price) || 0,
        originalprice: parseFloat(pkg.originalprice || pkg.orginalprice) || 0,
        period: pkg.period || 'Monthly',
        baseCurrency: pkg.base_currency || 'INR',
        image: pkg.image,
        heading: pkg.heading,
        description: pkg.description,
        sms: pkg.sms || "0",
        whatsup_count: pkg.whatsup_count || "0",
        email: pkg.email || "0",
        patient_count: pkg.patient_count || "0",
        socialposts: pkg.socialposts || "0",
        socialvideos: pkg.socialvideos || "0",
        website_pages: pkg.website_pages || "0",
        autopost: pkg.autopost || "no",
        chatsupport: pkg.chatsupport || "no",
        featureddays: pkg.featureddays || "0",
        hms: pkg.hms || "no",
        featuredprofile: pkg.featuredprofile || "no",
        professionalwebsite: pkg.professionalwebsite || pkg.profesionalwebsite || "no",
        brochures: pkg.brochures || "no",
        articles: pkg.articles || "no",
        awards: pkg.awards || "no",
        memberships: pkg.memberships || "no",
        duration: pkg.duration || 0,
        key: pkg.slug || pkg.name?.toLowerCase(),
        status: pkg.status,
        popular: pkg.popular === '1' || pkg.popular === true
      };
    }
    
    return null;
  } catch (error) {
    console.error('Error fetching package:', error);
    return null;
  }
};

export const getServiceById = async (serviceId) => {
  try {
    const tableSchema = "";
    const tableName = "ourservices";
    const conditions = { id: serviceId, status: 'active' };
    const orderBy = "id DESC";
    const search = {};
    const pagination = {};
    const margedata = [];

    const response = await oneKlicks.read(tableSchema, tableName, conditions, orderBy, search, pagination, margedata);
    
    if (response.success && response.data && response.data.length > 0) {
      const service = response.data[0];
      return {
        id: service.id,
        slug: service.slug,
        title: service.name,
        description: service.description,
        basePrice: parseFloat(service.base_price) || 0,
        baseCurrency: service.base_currency || 'INR',
        icon: service.icon || '🏥',
        category: service.category || 'general',
        features: JSON.parse(service.features || '[]')
      };
    }
    
    return null;
  } catch (error) {
    console.error('Error fetching service:', error);
    return null;
  }
};
